import {useEffect} from 'react';
import {useNavigate} from 'react-router-dom';
import {useAuth} from '../context/AuthContext';
import {startPushNotifications,stopPushNotifications,refreshPushRegistration} from '../services/pushNotifications';
export default function PushNotificationLifecycle(){
  const {user,isReview,erpInactive,loading,error}=useAuth();const navigate=useNavigate(),uid=user?.uid;
  useEffect(()=>{
    if(loading)return;
    if(!uid||erpInactive||error){stopPushNotifications();return;}
    startPushNotifications({uid,isReview,onOpen:path=>navigate(path)});
  },[uid,isReview,erpInactive,loading,error,navigate]);
  useEffect(()=>{let last=0;const refresh=()=>{if(document.visibilityState==='hidden'||Date.now()-last<60000)return;last=Date.now();refreshPushRegistration().catch(()=>{});};window.addEventListener('focus',refresh);window.addEventListener('online',refresh);document.addEventListener('visibilitychange',refresh);return()=>{window.removeEventListener('focus',refresh);window.removeEventListener('online',refresh);document.removeEventListener('visibilitychange',refresh);};},[]);
  return null;
}
